export const IsNull = (value) => {
    if (value === undefined || value === null) {
        return true;
    }

    if (value == "undefined" || value === "null") {
        return true;
    }
    if (value == "" || value == " ") {
        return true;
    }
    return false;


}


export const localStoreObjects = {
    userId: "userId",
    bgmiProfile: "bgmiProfile",
    profilePic: "profilePic",
    step: "step"
}

export const setLocalItem = (key, value) => {
    localStorage.setItem(key, value);
}
export const getLocalItem = (key) => {
    return localStorage.getItem(key);
}


export function convertDate(dateStr) {
    // Convert string to Date object
    const date = new Date(dateStr);

    // Format as "Month Day, Year"
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
}